import React from 'react'
import './App.css';

import About from './components/About';
import Header from './components/Header';
import Work from './components/Work';
import Msg from './components/Msg';
import Experience from './components/Experience';
import Testimonial from './components/Testimonial';
import Footer from './components/Footer';
import Education from './components/Education';

const Home = () => {
  return (
    <div className='app'>
        <Header/>
        <About/>
        <Work/>
        <Experience/>
        <Msg/>
        <Education/>
        {/* <Testimonial/> */}
        <Footer/>
    </div>
  )
}

export default Home